<script setup lang="ts">

import { useWelcomeFlowStore } from '../WelcomeFlowStore';
import { storeToRefs } from 'pinia';
import { WelcomeFlowPanel } from '../Types/WelcomeFlow.types';

import FindVehicle from '../Panels/FindVehicle.vue';
import LoadingPanel from '../../Components/FlowPanels/LoadingPanel.vue';
import ErrorPanel from '../Panels/ErrorPanel.vue';
import { onBeforeMount } from 'vue';

const welcomeFlowStore = useWelcomeFlowStore();

const { 
    currentPanel,
    loadingMessages
} = storeToRefs( welcomeFlowStore );


onBeforeMount( async () => await welcomeFlowStore.initialise() );

</script>

<template>
    <div class="page-content scroll
                bg-gradient-to-b dark:from-gray-900 via-40% dark:via-gray-850 dark:to-gray-900">
        <div class="flex flex-col items-center text-lg h-full tracking-wider">

            <TabPanels v-model="currentPanel" 
                       class="w-full !h-full pb-4 flex-grow"
                       :touch="{ left: null, right: null }">
            
                <!-- FIND VEHICLE -->
                <TabPanel :value="WelcomeFlowPanel.FindVehicle" class="flex flex-col h-full">
                    <FindVehicle />
                </TabPanel>

                <!-- LOADING -->
                <TabPanel :value="WelcomeFlowPanel.LoadingPanel" class="flex flex-col h-full">
                    <LoadingPanel :loadingMessages="loadingMessages" />
                </TabPanel>

                <!-- ERROR -->
                <TabPanel :value="WelcomeFlowPanel.ErrorPanel" class="flex flex-col h-full">
                    <ErrorPanel />
                </TabPanel>

                <!-- APP SELECTION -->
                <!-- <TabPanel :value="WelcomeFlowPanel.OriginatorCode" class="flex flex-col h-full">
                    <OriginatorCode />
                </TabPanel> -->

                <!-- <TabPanel :value="WelcomeFlowPanel.SelectApp" class="flex flex-col h-full">
                    <SelectApp @back="() => { welcomeFlowStore.goto( WelcomeFlowPanel.OriginatorCode ); }" />
                </TabPanel> -->

                <!-- CONSUMER DETAILS -->
                <!-- <TabPanel :value="WelcomeFlowPanel.ContactDetails" class="flex flex-col h-full">
                    <ContactDetails />
                </TabPanel> -->

                <!-- VERIFY MOBILE -->
                <!-- <TabPanel :value="WelcomeFlowPanel.VerifyMobile" class="flex flex-col h-full">
                    <VerifyMobile />
                </TabPanel> -->

            </TabPanels>

        </div>

    </div>

</template>